module.exports = __webpack_public_path__ + "static/img/TY.930f8b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/TY.jpg
// module id = xOA6
// module chunks = 1